module.exports = __webpack_public_path__ + "media/application/images/2018/loading-balls-a4b42eb1b4a0f1fd9c88588545ed6acd.svg";